import type { IntlShape } from "react-intl";

import {
    optionsAdministrative,
    optionsFinancial,
    optionsTechnical,
    optionsVolksTotalPortal,
    supportStatusOptions,
    supportSubjectOptions,
    SupportType,
} from "./constants";

interface SubjectOption {
    id: string;
    label: string;
}

const toSelectOptions = (intl: IntlShape, options: { id: string; labelId: string }[]): SubjectOption[] =>
    options.map(option => ({ id: option.id, label: intl.formatMessage({ id: option.labelId }) }));

export const getSupportSubjectOptions = (
    intl: IntlShape,
    supportType?: string,
    allOption?: SubjectOption,
) => {
    const options = toSelectOptions(
        intl,
        supportType === "TECHNICAL_SUPPORT" ? supportSubjectOptions : supportStatusOptions,
    );

    return allOption ? [...options, allOption] : options;
};

export const getSupportThemeOptions = (intl: IntlShape, subject?: string) => {
    if (subject === SupportType.ADMINISTRATIVE) {
        return toSelectOptions(intl, optionsAdministrative);
    }

    if (subject === SupportType.FINANCIAL) {
        return toSelectOptions(intl, optionsFinancial);
    }

    if (subject === SupportType.PORTAL) {
        return toSelectOptions(intl, optionsVolksTotalPortal);
    }

    if (subject === SupportType.TECHNICAL) {
        return toSelectOptions(intl, optionsTechnical);
    }

    return [];
};
